// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__d0We4","description":"MealItem_description__vPhk3","price":"MealItem_price__3No9u"};